export default __webpack_public_path__ + "assets/images/Copy-a7a9835a3afc85e5bb2b4f57b192b7d5.svg";